import styled from "styled-components";

export const CloseButtonContainer = styled.div`
  width: 16px;
  height: 16px;
  // Width of the modal is 1160, minus the 16px width of this div
  margin-left: 1144px;
  margin-bottom: 12px;

  svg {
    cursor: pointer;
  }
`;

export const MainContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #ebeafb;
  border-radius: 2px;
  box-sizing: border-box;
  min-height: 628px;
`;

export const Header = styled.div`
  color: #212530;
  font-family: "MaisonNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.75px;
  text-align: left;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-left: 40px;
  padding-right: 28px;
  border-bottom: ${props =>
    props.noBorder ? null : "1px solid rgb(155,155,194,0.5)"};
`;

export const ClientName = styled.div`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.13px;
  margin-bottom: 4px;
`;

export const FeedNameAndType = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.43px;
  // Necessary to properly align the bold span
  line-height: 18px;

  span {
    font-weight: 700;
    margin-left: 4px;
    display: flex;
    align-items: center;
  }

  svg {
    margin-left: 4px;
    margin-right: 4px;
  }
`;

export const TableContainer = styled.div`
  padding: 40px 28px 56px 28px;
  overflow: auto;
}
`;

export const Table = styled.table`
  font-weight: 400;
  letter-spacing: 0.39px;
  border: 1px solid #f5f5fb;
  border-collapse: separate;
  border-spacing: 0px;

  th {
    min-width: 120px;
    max-width: 120px;
    width: 120px;
    height: 40px;
    box-sizing: border-box;
    background-color: #eaeaf8;
    color: #2a2a3d;
    padding: 0px 16px;
    font-size: 10px;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    :not(:last-child) {
      border-right: 1px solid #f5f5fb;
    }

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  td {
    min-width: 120px;
    max-width: 120px;
    width: 120px;
    height: 40px;
    box-sizing: border-box;
    color: #212530;
    padding: 0px 16px;
    font-size: 11px;
    letter-spacing: 0.39px;
    border-top: 1px solid #f5f5fb;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    :not(:last-child) {
      border-right: 1px solid #f5f5fb;
    }

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const EmptyFilePreview = styled(TableContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;
